const RoleColors = {
  Admin: "error",
  Scorer: "info",
  author: "warning",
  maintainer: "success",
  subscriber: "primary"
}
export default RoleColors